import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';
import ContactPhoto from '../assets/contact-photo.jpg';

function Contact() {
  const formRef = useRef(null);
  const [statusMessage, setStatusMessage] = useState('');
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const onCaptchaChange = (value) => {
    setIsCaptchaVerified(!!value);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (!isCaptchaVerified) {
      setStatusMessage('Please complete the CAPTCHA to proceed.');
      return;
    }

    emailjs
      .sendForm(
        'service_xd4zuwd',       // Replace with your EmailJS service ID
        'template_2jdkpyk',       // Replace with your EmailJS template ID
        formRef.current,
        '38BZt8PKdissr2Wbo'       // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log('Email sent:', result.text);
          setStatusMessage('Your message has been sent!');
          formRef.current.reset();
          setIsCaptchaVerified(false);
        },
        (error) => {
          console.error('Error sending email:', error.text);
          setStatusMessage('Oops, something went wrong. Please try again.');
        }
      );
  };

  return (
    <div style={styles.container}>
      {/* Hero Section */}
      <div style={styles.heroSection}>
        <img src={ContactPhoto} alt="Contact Illustration" style={styles.heroImage} />
        <div style={styles.heroOverlay}>
          <h1 style={styles.heroHeading}>Contacteaza-ne</h1>
          <p style={styles.heroSubheading}></p>
        </div>
      </div>

      {/* Form Section */}
      <div style={styles.formSection}>
        <form ref={formRef} onSubmit={sendEmail} style={styles.form}>
          <div style={styles.miniFormRow}>
            <input
              type="date"
              placeholder="Data"
              name="booking_date"
              style={styles.miniInput}
              required
            />
          </div>
          <div style={styles.miniFormRow}>
            <input
              type="number"
              placeholder="Numar de persoane"
              name="numar_persoane"
              style={styles.miniInput}
              required
            />
          </div>
          <div style={styles.miniFormRow}>
            <input
              type="email"
              placeholder="Adresa de email"
              name="from_email"
              style={styles.miniInput}
              required
            />
          </div>
          <div style={styles.miniFormRow}>
            <input
              type="text"
              placeholder="Numele tau"
              name="from_name"
              style={styles.miniInput}
              required
            />
          </div>
          <div style={styles.miniFormRow}>
            <select name="trip_type" style={styles.miniInput} required>
              <option value="">Selecteaza tipul de tur</option>
              <option value="Tur Pietonal">Tur Pietonal</option>
              <option value="Tur Regional">Tur Regional</option>
              <option value="Experienta Interactiva">Experienta Interactiva</option>
            </select>
          </div>
          {/* Hidden fields for EmailJS */}
          <input
            type="hidden"
            name="to_name"
            value="Liv Tu Visit"
          />
          <input
            type="hidden"
            name="subject"
            value="Mini Contact Booking Request"
          />
          <div style={styles.miniFormRow}>
            <textarea
              placeholder="Mesajul tau..."
              name="message"
              style={styles.miniTextarea}
              required
            ></textarea>
          </div>
          <div style={styles.recaptcha}>
            <ReCAPTCHA
              sitekey="6LdIJdEqAAAAAIjUCxrJSAAz6SUsSJ2z24ySvMXd"
              onChange={onCaptchaChange}
            />
          </div>
          <div style={styles.miniFormRow}>
            <button
              type="submit"
              style={styles.miniButton}
              disabled={!isCaptchaVerified}
            >
              Contacteaza-ne
            </button>
          </div>
        </form>
        {statusMessage && <p style={styles.statusMessage}>{statusMessage}</p>}
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#F4F9F9",
    fontFamily: "'Georgia', serif",
    margin: "0",
    padding: "0",
  },
  heroSection: {
    position: "relative",
    width: "100%",
    height: "40vh",
    overflow: "hidden",
  },
  heroImage: {
    position: 'absolute',
    top: '-70%',       // crop top by shifting up
    left: '50%',
    width: '100%',
    height: '180%',    // zoom in vertically to crop
    transform: 'translateX(-50%)',
    objectFit: 'cover',
  },
  heroOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    color: "#FFFFFF",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "1rem",
    borderRadius: "8px",
  },
  heroHeading: {
    fontSize: "2.5rem",
    marginBottom: "0.5rem",
  },
  heroSubheading: {
    fontSize: "1.2rem",
  },
  formSection: {
    padding: "2rem",
    maxWidth: "800px",
    margin: "0 auto",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
  // Updated miniFormRow style: now each row is one under the other
  miniFormRow: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    width: "100%",
  },
  miniInput: {
    padding: "0.75rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    width: "100%",
  },
  miniTextarea: {
    width: "100%",
    padding: "0.75rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    minHeight: "80px",
    resize: "vertical",
  },
  recaptcha: {
    margin: "1rem 0",
    display: "flex",
    justifyContent: "center",
  },
  miniButton: {
    padding: "0.8rem 1.5rem",
    backgroundColor: "#C39A79",
    color: "#FFFFFF",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "bold",
    transition: "background-color 0.3s",
    alignSelf: "center",
  },
  statusMessage: {
    marginTop: "1rem",
    fontWeight: "bold",
    color: "#2C3E50",
    textAlign: "center",
  },
};

export default Contact;
